import type { ElementType } from 'react';

interface FixedLinesProps {
  lines: string[];
  as?: ElementType;
  className?: string;
  lineClassName?: string;
}

export default function FixedLines({
  lines,
  as: Component = 'div',
  className,
  lineClassName,
}: FixedLinesProps) {
  return (
    <Component className={className}>
      {lines.map((line) => (
        <span key={line} className={lineClassName ? `block ${lineClassName}` : 'block'}>
          {line}
        </span>
      ))}
    </Component>
  );
}
